import { setReplicaList } from '../actions/internalActions';
import getFolderTable from '../selectors/getFolderTable';
import { mutator } from 'satcheljs';

export default mutator(setReplicaList, actionMessage => {
    const folder = getFolderTable().get(actionMessage.folderId);

    if (folder) {
        folder.ReplicaList = actionMessage.replicaList;
    }
});
